import { withWindow } from '@shared/utils/withWindow';

export const getReferrer = () =>
  withWindow(win => {
    const referrer = win.document.referrer;
    return referrer && referrer !== win.location.href ? referrer : '';
  }, '');
